window._ = require('lodash')
// window.Popper = require('popper.js').default;

try {
  window.$ = window.jQuery = require('jquery');

  window.Scrollbar = require('smooth-scrollbar').default;
  // require('bootstrap');
  require('slick-carousel');
  require('jquery-validation');
} catch (e) {}




// WEBPACK FOOTER //
// ./resources/assets/frontend/js/bootstrap.js